require('../../shared/leaguesService');

angular.module('app.admin.adGenerator.adGeneratorService', [
  'app.shared.leaguesService'
])
  .factory('app.admin.adGenerator.adGeneratorService', [
    '$http',
    '$q',
    'app.shared.leaguesService',
    function ($http, $q, leaguesService) {
      "use strict";

      return {
        getLeagues: function () {
          return leaguesService.getList();
        },
        getTeams: function (league_id) {
          return leaguesService.getTeams(league_id);
        },
        getSizes: function () {
          let deferred = $q.defer();

          deferred.resolve({
            data: [
              '728x90',
              '300x250'
            ]
          });

          return deferred.promise;
        },
        getAd: function (type, id, size) {
          if (type && id && size) {
            return $http.get(window.location.api('ad_builder/' + type + '?id=' + id + '&size=' + size));
          }
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/adGenerator/adGeneratorService.js